import "./TestimonialsReviews.module.css";
import PureDetailHeader from "@/reusable_sections/Header";
import CustomerTestimonialsSlider from "./sections/CustomerTestimonialsSlider";
import ShareYourExperience from "./sections/ShareYourExperience";
import PureDetailFooter from "@/reusable_sections/Footer";
export default function TestimonialsReviewsPage() {
  return <div>
      <PureDetailHeader />
      <CustomerTestimonialsSlider />
      <ShareYourExperience />
      <PureDetailFooter />
    </div>;
}